





















































































































import Vue from 'vue';
import { EventBus } from '@/event-bus';
import { mapGetters } from 'vuex';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import { VendorAddress } from '@/models/addressBook/VendorAddress';

import addressService from '@/services/AddressService';
import exportService from '@/services/ExportService';
import localStorageService from '@/services/LocalStorageService';
import miscService from '@/services/MiscService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      loading: false,
      term: '',
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    backToPrevPage() {
      miscService.goBack();
    },
    onClear() {
      this.term = '';
      this.applyFilters();
    },
    fetch() {
      this.loading = true;
      const client = localStorageService.get('selected-afs-client');
      addressService.getAllByVendorId(client.id).then((x: VendorAddress[]) => {
        this.$store.commit('clientAddresses/setAddresses', x);

        this.applyFilters();
        this.loading = false;
      });
    },
    applyFilters() {
      let items = this.all;

      if (this.term) {
        const q = this.term?.toLowerCase();
        items = items.filter(
          (x) =>
            x.company?.toLowerCase().includes(q) ||
            x.contact?.toLowerCase().includes(q) ||
            x.email?.toLowerCase().includes(q) ||
            x.phone?.toLowerCase().includes(q) ||
            x.address1?.toLowerCase().includes(q) ||
            x.city?.toLowerCase().includes(q) ||
            x.state?.toLowerCase().includes(q) ||
            x.postalCode?.toLowerCase().includes(q) ||
            x.firstName?.toLowerCase().includes(q) ||
            x.lastName?.toLowerCase().includes(q)
        );
      }

      this.$store.commit('clientAddresses/setFilteredAddresses', items);
      this.$store.commit(
        'clientAddresses/setPage',
        items.slice(0, this.pageSize)
      );
      this.currentPage = 1;
    },
    csvExport() {
      const client = localStorageService.get('selected-afs-client');
      exportService.csvDownload(this.all, `${client?.company}’s Address Book`);
    },
    pageChange(newPage) {
      let page = this.filteredAddresses.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
      this.$store.commit('clientAddresses/setPage', page);
    },
    openAddNewAddressForm() {
      EventBus.$emit('settings-address-book-create-new');
    },
  },
  computed: {
    ...mapGetters('clientAddresses', ['all', 'page', 'filteredAddresses']),
    pageHeader() {
      return `${this.client?.company}’s Address Book`;
    },
    client() {
      return localStorageService.get('selected-afs-client');
    },
    pagingLength() {
      return Math.ceil(this.filteredAddresses.length / this.pageSize);
    },
    backToLbl() {
      return document.referrer?.includes('/dashboard')
        ? 'Back to Dashboard'
        : 'Back to Clients';
    },
    addressCount() {
      const count = this.formatWeight(this.filteredAddresses.length);
      if (count == '0.00') return 0;

      return count;
    },
  },
});
